import commonEn from './en/common.json'
import components_contractCardEn from './en/components_contractCard.json'
import components_paidFeatureEn from './en/components_paidFeature.json'
import components_swipeMenuEn from './en/components_swipeMenu.json'
import consumptionElementsEn from './en/consumptionElements.json'
import modalsEn from './en/modals.json'
import modals_badgesEn from './en/modals_badges.json'
import modals_changelogEn from './en/modals_changelog.json'
import modals_consumptionElementDetailInfoEn from './en/modals_consumptionElementDetailInfo.json'
import modals_consumptionElementDetailsEn from './en/modals_consumptionElementDetails.json'
import modals_contractOptionsEn from './en/modals_contractOptions.json'
import modals_createContractEn from './en/modals_createContract.json'
import modals_dhInstructionsEn from './en/modals_dhInstructions.json'
import modals_elementAdderEn from './en/modals_elementAdder.json'
import modals_generalContactEn from './en/modals_generalContact.json'
import modals_getOurContractEn from './en/modals_getOurContract.json'
import modals_invoiceDetailEn from './en/modals_invoiceDetail.json'
import modals_moveOutContactEn from './en/modals_moveOutContact.json'
import modals_priceInformationModalEn from './en/modals_priceInformationModal.json'
import modals_spGoalAdderEn from './en/modals_spGoalAdder.json'
import modals_trackerModalEn from './en/modals_trackerModal.json'
import pagesEn from './en/pages.json'
import pages_addSmartDeviceEn from './en/pages_addSmartDevice.json'
import pages_apartmentDetailEn from './en/pages_apartmentDetail.json'
import pages_authorizationsEn from './en/pages_authorizations.json'
import pages_consumptionElementsEn from './en/pages_consumptionElements.json'
import pages_contactEn from './en/pages_contact.json'
import pages_contactSupportEn from './en/pages_contactSupport.json'
import pages_contractConfirmationEn from './en/pages_contractConfirmation.json'
import pages_contractInformationEn from './en/pages_contractInformation.json'
import pages_createUserEn from './en/pages_createUser.json'
import pages_downloadAppEn from './en/pages_downloadApp.json'
import pages_electricCarEn from './en/pages_electricCar.json'
import pages_electricityEn from './en/pages_electricity.json'
import pages_enodeInitEn from './en/pages_eNodeInit.json'
import pages_forgottenPasswordEn from './en/pages_forgottenPassword.json'
import pages_hvacEn from './en/pages_hvac.json'
import pages_insufficientVersionEn from './en/pages_insufficientVersion.json'
import pages_invoiceExtensionEn from './en/pages_invoiceExtension.json'
import pages_invoicesEn from './en/pages_invoices.json'
import pages_loadingPageEn from './en/pages_loadingPage.json'
import pages_loginEn from './en/pages_login.json'
import pages_mainTabsEn from './en/pages_mainTabs.json'
import pages_monthlyReportEn from './en/pages_monthlyReport.json'
import pages_monthlyReportsListEn from './en/pages_monthlyReportsList.json'
import pages_noConnectionEn from './en/pages_noConnection.json'
import pages_notificationsEn from './en/pages_notifications.json'
import objectInquiryPageEn from './en/pages_objectInquiry.json'
import pages_objectSelectorEn from './en/pages_objectSelector.json'
import pages_onboardingEn from './en/pages_onboarding.json'
import pages_overviewEn from './en/pages_overview.json'
import pages_permissionFormEn from './en/pages_permissionForm.json'
import pages_savingEn from './en/pages_saving.json'
import pages_serverErrorEn from './en/pages_serverError.json'
import pages_settingsEn from './en/pages_settings.json'
import pages_solarPanelDetailEn from './en/pages_solarPanelDetail.json'
import pages_welcomeEn from './en/pages_welcome.json'
import slide_meteringPointInformationFormEn from './en/slide_meteringPointInformationForm.json'
import commonFi from './fi/common.json'
import components_contractCardFi from './fi/components_contractCard.json'
import components_paidFeatureFi from './fi/components_paidFeature.json'
import components_swipeMenuFi from './fi/components_swipeMenu.json'
import consumptionElementsFi from './fi/consumptionElements.json'
import modalsFi from './fi/modals.json'
import modals_badgesFi from './fi/modals_badges.json'
import modals_changelogFi from './fi/modals_changelog.json'
import modals_consumptionElementDetailInfoFi from './fi/modals_consumptionElementDetailInfo.json'
import modals_consumptionElementDetailsFi from './fi/modals_consumptionElementDetails.json'
import modals_contractOptionsFi from './fi/modals_contractOptions.json'
import modals_createContractFi from './fi/modals_createContract.json'
import modals_dhInstructionsFi from './fi/modals_dhInstructions.json'
import modals_elementAdderFi from './fi/modals_elementAdder.json'
import modals_generalContactFi from './fi/modals_generalContact.json'
import modals_getOurContractFi from './fi/modals_getOurContract.json'
import modals_invoiceDetailFi from './fi/modals_invoiceDetail.json'
import modals_moveOutContactFi from './fi/modals_moveOutContact.json'
import modals_priceInformationModalFi from './fi/modals_priceInformationModal.json'
import modals_spGoalAdderFi from './fi/modals_spGoalAdder.json'
import modals_trackerModalFi from './fi/modals_trackerModal.json'
import pagesFi from './fi/pages.json'
import pages_addSmartDeviceFi from './fi/pages_addSmartDevice.json'
import pages_apartmentDetailFi from './fi/pages_apartmentDetail.json'
import pages_authorizationsFi from './fi/pages_authorizations.json'
import pages_consumptionElementsFi from './fi/pages_consumptionElements.json'
import pages_contactFi from './fi/pages_contact.json'
import pages_contactSupportFi from './fi/pages_contactSupport.json'
import pages_contractConfirmationFi from './fi/pages_contractConfirmation.json'
import pages_contractInformationFi from './fi/pages_contractInformation.json'
import pages_createUserFi from './fi/pages_createUser.json'
import pages_downloadAppFi from './fi/pages_downloadApp.json'
import pages_electricCarFi from './fi/pages_electricCar.json'
import pages_electricityFi from './fi/pages_electricity.json'
import pages_enodeInitFi from './fi/pages_eNodeInit.json'
import pages_forgottenPasswordFi from './fi/pages_forgottenPassword.json'
import pages_hvacFi from './fi/pages_hvac.json'
import pages_insufficientVersionFi from './fi/pages_insufficientVersion.json'
import pages_invoiceExtensionFi from './fi/pages_invoiceExtension.json'
import pages_invoicesFi from './fi/pages_invoices.json'
import pages_loadingPageFi from './fi/pages_loadingPage.json'
import pages_loginFi from './fi/pages_login.json'
import pages_mainTabsFi from './fi/pages_mainTabs.json'
import pages_monthlyReportFi from './fi/pages_monthlyReport.json'
import pages_monthlyReportsListFi from './fi/pages_monthlyReportsList.json'
import pages_noConnectionFi from './fi/pages_noConnection.json'
import pages_notificationsFi from './fi/pages_notifications.json'
import objectInquiryPageFi from './fi/pages_objectInquiry.json'
import pages_objectSelectorFi from './fi/pages_objectSelector.json'
import pages_onboardingFi from './fi/pages_onboarding.json'
import pages_overviewFi from './fi/pages_overview.json'
import pages_permissionFormFi from './fi/pages_permissionForm.json'
import pages_savingFi from './fi/pages_saving.json'
import pages_serverErrorFi from './fi/pages_serverError.json'
import pages_settingsFi from './fi/pages_settings.json'
import pages_solarPanelDetailFi from './fi/pages_solarPanelDetail.json'
import pages_welcomeFi from './fi/pages_welcome.json'
import slide_meteringPointInformationFormFi from './fi/slide_meteringPointInformationForm.json'

const resources = {
	en: {
		common: commonEn,
		pages_electricity: pages_electricityEn,
		pages_invoices: pages_invoicesEn,
		components_contractCard: components_contractCardEn,
		components_paidFeature: components_paidFeatureEn,
		components_swipeMenu: components_swipeMenuEn,
		pages_apartmentDetail: pages_apartmentDetailEn,
		modals_consumptionElementDetailInfo: modals_consumptionElementDetailInfoEn,
		modals_consumptionElementDetails: modals_consumptionElementDetailsEn,
		modals_dhInstructions: modals_dhInstructionsEn,
		pages_electricCar: pages_electricCarEn,
		modals_elementAdder: modals_elementAdderEn,
		modals_invoiceDetail: modals_invoiceDetailEn,
		modals_priceInformationModal: modals_priceInformationModalEn,
		modals_spGoalAdder: modals_spGoalAdderEn,
		modals_trackerModal: modals_trackerModalEn,
		modals_contractOptions: modals_contractOptionsEn,
		pages_consumptionElements: pages_consumptionElementsEn,
		pages_createUser: pages_createUserEn,
		pages_authorizations: pages_authorizationsEn,
		pages_forgottenPassword: pages_forgottenPasswordEn,
		pages_loadingPage: pages_loadingPageEn,
		pages_login: pages_loginEn,
		pages_mainTabs: pages_mainTabsEn,
		pages_monthlyReport: pages_monthlyReportEn,
		pages_monthlyReportsList: pages_monthlyReportsListEn,
		pages_noConnection: pages_noConnectionEn,
		pages_objectSelector: pages_objectSelectorEn,
		pages_onboarding: pages_onboardingEn,
		pages_overview: pages_overviewEn,
		pages_permissionForm: pages_permissionFormEn,
		pages_saving: pages_savingEn,
		pages_insufficientVersion: pages_insufficientVersionEn,
		pages_welcome: pages_welcomeEn,
		pages_addSmartDevice: pages_addSmartDeviceEn,
		modals: modalsEn,
		pages: pagesEn,
		pages_serverError: pages_serverErrorEn,
		pages_contactSupport: pages_contactSupportEn,
		modals_getOurContract: modals_getOurContractEn,
		modals_createContract: modals_createContractEn,
		modals_changelog: modals_changelogEn,
		consumptionElements: consumptionElementsEn,
		modals_moveOutContact: modals_moveOutContactEn,
		modals_generalContact: modals_generalContactEn,
		pages_invoiceExtension: pages_invoiceExtensionEn,
		pages_settings: pages_settingsEn,
		modals_badges: modals_badgesEn,
		pages_objectInquiry: objectInquiryPageEn,
		pages_contact: pages_contactEn,
		pages_notifications: pages_notificationsEn,
		pages_hvac: pages_hvacEn,
		pages_enodeInit: pages_enodeInitEn,
		pages_contractConfirmation: pages_contractConfirmationEn,
		pages_contractInformation: pages_contractInformationEn,
		pages_downloadApp: pages_downloadAppEn,
		slide_meteringPointInformationForm: slide_meteringPointInformationFormEn,
		pages_solarPanelDetail: pages_solarPanelDetailEn,
	},
	fi: {
		common: commonFi,
		pages_electricity: pages_electricityFi,
		pages_invoices: pages_invoicesFi,
		components_contractCard: components_contractCardFi,
		components_paidFeature: components_paidFeatureFi,
		components_swipeMenu: components_swipeMenuFi,
		pages_apartmentDetail: pages_apartmentDetailFi,
		modals_consumptionElementDetailInfo: modals_consumptionElementDetailInfoFi,
		modals_consumptionElementDetails: modals_consumptionElementDetailsFi,
		modals_dhInstructions: modals_dhInstructionsFi,
		pages_electricCar: pages_electricCarFi,
		modals_elementAdder: modals_elementAdderFi,
		modals_invoiceDetail: modals_invoiceDetailFi,
		modals_priceInformationModal: modals_priceInformationModalFi,
		modals_spGoalAdder: modals_spGoalAdderFi,
		modals_trackerModal: modals_trackerModalFi,
		modals_contractOptions: modals_contractOptionsFi,
		pages_consumptionElements: pages_consumptionElementsFi,
		consumptionElements: consumptionElementsFi,
		pages_createUser: pages_createUserFi,
		pages_authorizations: pages_authorizationsFi,
		pages_forgottenPassword: pages_forgottenPasswordFi,
		pages_loadingPage: pages_loadingPageFi,
		pages_login: pages_loginFi,
		pages_mainTabs: pages_mainTabsFi,
		pages_monthlyReport: pages_monthlyReportFi,
		pages_monthlyReportsList: pages_monthlyReportsListFi,
		pages_noConnection: pages_noConnectionFi,
		pages_objectSelector: pages_objectSelectorFi,
		pages_onboarding: pages_onboardingFi,
		pages_overview: pages_overviewFi,
		pages_permissionForm: pages_permissionFormFi,
		pages_saving: pages_savingFi,
		pages_insufficientVersion: pages_insufficientVersionFi,
		pages_welcome: pages_welcomeFi,
		pages_addSmartDevice: pages_addSmartDeviceFi,
		modals: modalsFi,
		pages: pagesFi,
		pages_contactSupport: pages_contactSupportFi,
		modals_getOurContract: modals_getOurContractFi,
		modals_createContract: modals_createContractFi,
		modals_changelog: modals_changelogFi,
		modals_moveOutContact: modals_moveOutContactFi,
		modals_generalContact: modals_generalContactFi,
		pages_invoiceExtension: pages_invoiceExtensionFi,
		pages_settings: pages_settingsFi,
		modals_badges: modals_badgesFi,
		pages_objectInquiry: objectInquiryPageFi,
		pages_serverError: pages_serverErrorFi,
		pages_contact: pages_contactFi,
		pages_notifications: pages_notificationsFi,
		pages_hvac: pages_hvacFi,
		pages_enodeInit: pages_enodeInitFi,
		pages_contractConfirmation: pages_contractConfirmationFi,
		pages_contractInformation: pages_contractInformationFi,
		pages_downloadApp: pages_downloadAppFi,
		slide_meteringPointInformationForm: slide_meteringPointInformationFormFi,
		pages_solarPanelDetail: pages_solarPanelDetailFi,
	},
} as const

export default resources
